import ChartNivKoortsBijNeutropenie from "../../../../src/client/niv_acuteboekje/json/koorts-bij-neutropenie.json";
import ChartNivSimple from "../../../../src/client/niv_acuteboekje/interactions/simple/ChartNivSimple.js";
import ButtonSchematic from "../../../../src/client/niv_acuteboekje/ui/ButtonSchematic.js";
import * as React from 'react';
export default {
  ChartNivKoortsBijNeutropenie,
  ChartNivSimple,
  ButtonSchematic,
  React
};